<template>
  <div class="footer-container">
    <div>
      <!-- 左侧链接区域 -->
      <div class="left">
        <!-- 第一行：关于我们 -->
        <div class="col1">
          <p class="label">关于我们</p>
          <div>
            <span
              v-for="item of aboutUs"
              :key="item.id"
              @click="toDetail(item, '关于我们')"
              >{{ item.title }}</span
            >
          </div>
        </div>
        <!-- 第二行：联系方式 -->
<div class="flex-container">
<div class="col2">
          <p class="label">联系方式</p>
          <div>
            <span
              v-for="item of touchs"
              :key="item.id"
              @click="toDetail(item, '联系方式')"
              >{{ item.title }}</span
            >
          </div>
        </div>
 
  <div class="clo22">
          <p class="label2">个人信息泄漏投诉举报</p>
          <div>
            <span
              v-for="item of touchs"
              :key="item.id"
              @click="toDetail(item, '联系方式')"
              >{{ item.title }}</span
            >
          </div>
        </div>
</div>
  
 



      
         
        <!-- 第四行：友情链接 -->
        <div   style="margin-top:30px;">
          <p class="label" style="margin-top:36px;;width:130px;display: inline-block;">友情链接</p>

            <div  style=" display: inline-block; ">
               <el-link v-for="item in links" :key='item.id' type="info"  style="white-space: nowrap;padding: 0 5px;display: inline-block;" :href="item.links" target="_blank">{{item.name}}</el-link>
            </div>
        </div>
        <!-- 第三行：合作伙伴,161*35 -->
        <div class="col3">
          <p class="label">合作伙伴</p>
          <div class="col3-box">
            <div class="col3-scroll-box">
              <img
                v-for="(item, index) of users"
                :src="item.imgUrl"
                :key="'img-' + index"
              />
              <div class="blocks" v-for="item of usersBlocks" :key="item"></div>
              <template v-if="users.length > 8">
                <img
                  v-for="(item, index) of users.slice(0, 8)"
                  :src="item.imgUrl"
                  :key="'img-2-' + index"
                />
              </template>
            </div>
          </div>
        </div>
      </div>
      <!-- 右侧二维码 -->
      <div class="right">
        <div class="demo-image__preview">
          <el-image 
            style="width: 100px; height: 100px"
            :src="url" 
            :preview-src-list="srcList">
          </el-image>
          
        </div>
        <div>
          <p class="title">政府信得过、企业离不开   社会反响好、自身过得硬</p>
          <p style="padding: 11px 0 10px">微信扫一扫关注我们</p>
          <p>版权由cds服务中心所有</p>
        </div>
      </div>
    </div>
    <div class="Copyright">Copyright © 2021 声明 中国航空运输协会 版权所有 <a target="_blank" class="copya" style="text-decoration: none; color:rgba(50,50,50,0.7);" href="https://beian.miit.gov.cn/#/Integrated/index">京公网安备 11010102005355号 京ICP备2021018351号-1</a></div>
  </div>
</template>

<script>
import axios from "axios";
import { Encrypt } from '@/utils/secret'

import { ImgBlobUrl } from "../utils/fileDownload";

import iconmax from "../assets/241658363001_.pic.jpg";
import icommin from "../assets/301658365317_.pic.jpg";

export default {
  data() {
    return {
      url: icommin,
      srcList: [
        iconmax
        
      ],

      pages: { total: 0, current: 1, size: 10 },
      links:[],//友情链接
      aboutUs: [], // 关于我们
      touchs: [], // 联系方式
      users: [], // 合作伙伴列表
      usersBlocks: 0, // 补齐数

      timer: null, // 定时滚动
      timer2: null, // 防抖
    };
  },
  created() {
    // this.$eventBus.$on('set-footer', (infos) => {
    //   this.aboutUs = infos['关于我们'].slice(0, 6)
    //   this.touchs = infos['联系方式'].slice(0, 6)
    //   this.drawImg(infos['合作伙伴'])
    //   // this.users = infos['合作伙伴']
    // })
    this.getHomeListAll();
    this.getAllLinksMange();
  },
  watch: {
    users() {
      if (this.users.length <= 8) return;
      this.timer2 ? clearTimeout(this.timer2) : 0;
      this.thimer2 = setTimeout(() => {
        this.timer = this.startScroll();
      }, 1000);
    },
  },
  methods: {
    //获取友情链接
    getAllLinksMange(){
        this.$api.getAllLinksMange().then(res=>{
          this.links = (res.result).slice(0,10)
        }).catch(error=>{

        })
    },
    
    asyncTo(promise) {
      return promise.then((data) => [null, data]).catch((err) => [err]);
    },
    // 获取首页所有列表
   async getHomeListAll() {
      const titleList = [
        ["关于我们",'aboutUs'],
        ["联系方式",'touchs'],
        ["合作伙伴"]
      ]
      for (const iterator of titleList.entries()) {
        const [error, {result:{list}}] = await this.asyncTo(
          this.$api.columnList({
            entity: {
              column: iterator[1][0],
              pageNum: this.pages.current,
              pageSize: this.pages.size,
            },
            pageNum: this.pages.current,
            pageSize: this.pages.size,
          })
        );
        if (error) {
          return;
        }
        console.log(iterator[1][0] )
        if(iterator[1][0] == "合作伙伴"){
          this.drawImg(list)
        }else{
          this[iterator[1][1]] = Array.isArray(list)
          ? list.slice(0, 6)
          : [];
        }
      }  


      // this.$api.homeListAll({}).then((r) => {
      //   this.aboutUs = r.result.columnList["关于我们"]
      //     ? r.result.columnList["关于我们"].slice(0, 6)
      //     : [];
      //   this.touchs = r.result.columnList["联系方式"]
      //     ? r.result.columnList["联系方式"].slice(0, 6)
      //     : [];
      //   r.result.columnList["合作伙伴"]
      //     ? this.drawImg(r.result.columnList["合作伙伴"])
      //     : 0;
      // });
    },
    // 合作伙伴，都是展示图，但是接口没有链接，需要加载blob后展示
    drawImg(users) {
      users.forEach((e) => {
        this.$api.selectDescInfoById({ id: e.id }).then((r) => {
          const { filename: fileName, filePath: uuid } = JSON.parse(
            r.result.fileFullPath
          )[0];
          axios
            .get(
              process.env.VUE_APP_BASE_URL +
                "portalCenter/download?fileName=" +
                fileName +
                "&uuid=" +
                Encrypt(uuid),
              { responseType: "blob" }
            )
            .then((r) => {
              const fileReader = new FileReader();
              fileReader.onload = () => {
                // console.log(fileReader.result)
                this.users.push({ ...e, imgUrl: fileReader.result });
              };
              fileReader.readAsDataURL(r.data);
            })
            .catch((e) => {
              console.log("异步加载图片blob数据 -- 失败");
              // this.users.push({ ...e, imgUrl: '' })
            })
            .finally((_) => {
              // 为了保证合作伙伴的显示效果，每行4个，不够的补齐
              this.usersBlocks = 4 - (users.length % 4);
            });
        });
      });
    },
    // 跳转到文章详情页
    toDetail(item, label) {
      this.$router.push({
        path: "/detail",
        query: { id: item.id, label },
      });
    },
    // 开始滚动
    startScroll() {
      let top = 0;
      this.timer = clearInterval(this.timer);
      return setInterval(() => {
        this.$nextTick(() => {
          const dom = document.getElementsByClassName("col3-scroll-box")[0];
          const height = dom.scrollHeight - 100;
          Math.abs(top) >= height ? (top = 0) : (top -= 0.5); // 0.5 15的频率最合适
          dom.style.top = top + "px";
        });
      }, 15);
    },
  },
};
</script>

<style lang="less" scoped>
.copya:hover {
  color: rgb(68, 67, 67);
}
.footer-container {
  position: relative;
  background-color: #ececec;
  padding-top: 72px;
  padding-bottom: 150px;
  // width: 1300px;
  // margin: auto;
  // min-width: 1903px;
  & > div {
    width: 1270px;
    margin: auto;
    display: flex;
    justify-content: space-between;
  }
  .Copyright{
    position: absolute;
    bottom: 10px;
    font-size: 16px;
    text-align: center;
    width: 100%;
    /* height: 20px; */
    display: block;
  }
  // 左侧链接区域
  .left {
    width: 815px;
    // flex-grow: 1;
    .label {
      width: 100px;
      font-size: 14px;
      color: #333333;
    }
    & > div {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      margin-bottom: 27px;
    }
    .col1 {
      & > div {
        width: 585px;
        display: flex;
        // justify-content: space-between;
        flex-wrap: wrap;
        font-size: 12px;
        color: #999999;
        span {
          cursor: pointer;
          margin: 0 30px 10px 0;
          &:active {
            opacity: 0.8;
          }
        }
      }
    }
   
    .col2 {
    display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      margin-bottom: 27px;
      & > div {
    
        width: 200px;
        display: flex;
        // justify-content: space-between;
        flex-wrap: wrap;
        font-size: 12px;
        color: #999999;
        span {
          cursor: pointer;
          margin: 0 30px 10px 0;
          &:active {
            opacity: 0.8;
          }
        }
      }
    }
     .clo22 {
        display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      margin-bottom: 27px;
    margin-left: 200px;
       .label2 {
      width: 180px;
      font-size: 14px;
      color: #333333;
    }
    & > div {
 
        width: 200px;
        display: flex;
        // justify-content: space-between;
        flex-wrap: wrap;
        font-size: 12px;
        color: #999999;
        span {
          cursor: pointer;
          margin: 0 30px 10px 0;
          &:active {
            opacity: 0.8;
          }
        }
       
      }
    }
    .col3 {
      margin-bottom: 0;
      .col3-box {
        width: 710px;
        height: 85px;
        overflow: hidden;
        .col3-scroll-box {
          position: relative;
          // transition: all 5s;
          width: 100%;
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          & > img {
            width: 161px;
            height: 35px;
            // margin-right: 22px;
            margin-bottom: 15px;
            border-radius: 3px;
          }
        }
      }
      // 弹性布局补齐块儿
      .blocks {
        width: 161px;
        height: 35px;
      }
    }
  }
  // 右侧二维码区域
  .right {
    width: 380px;
    height: 122px;
    display: flex;
    // justify-content: space-between;
    align-items: center;
    & > img {
      width: 122px;
      height: 122px;
    }
    & > div {
      padding-left: 20px;
    }
    .title {
      color: #01449b;
      font-size: 20px;
    }
    .title ~ p {
      color: #666666;
      font-size: 14px;
    }
  }
}
</style>
